// extracted by mini-css-extract-plugin
export default {"small-icon-container":"SharePopover__small-icon-container__Gfscp","smallIconContainer":"SharePopover__small-icon-container__Gfscp"};